module.exports = __webpack_public_path__ + "img/promoter_t1.126a5127.png";